module.exports = __webpack_public_path__ + "static/media/icon-plus.16c45045.svg";